
<div class="modal-header d-flex align-items-center">
  <h4 class="modal-title" class="d-flex align-items-center mb-0"><i class="material-icons basket-icon light me-2">
  shopping_basket </i>{{'ADD_TO_BASKET' | translate}} ({{'PREORDER' | translate}})</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>
<div class="px-0 pt-0 modal-body">
  <app-preorder-container #preorderContainer [articles]="[article]" [embedded]="true"
    [showButtons]="false" [hideSaveButton]="false" [preorderType]="articleType">
    <div topButtons class="py-2 px-0 container d-flex justify-content-between">
      @if (preorderContainer.basketId) {
        <a class="btn btn-primary basket-button" (click)="modal.dismiss('Cross click')"
          [routerLink]="'/' + preorderContainer.companyGroupCode + '/preorderBasket/' + articleType + '/' + preorderContainer.basketId">
          <i class="material-icons me-1" style="font-size: 18px; transform: translateY(2.5px);"> shopping_basket</i>
          {{
          'PREORDER_BASKET' |
        translate }}</a>
      }
    </div>
  </app-preorder-container>
</div>
<div class="modal-footer">

</div>
